import * as angular from "angular"
import { DatalayersMap, DatalayerZone, doclib, IDatalayerZoneMapInstance, ImportDocument } from "../../../omnia"
import { IDatalayerMapDependencies } from "../../../types"
import { EditFeature } from "../edit-feature"
import { ol_extent, ol_Map, ol_Overlay } from "@omnia/exports/openlayers"

export class Pictures {

    private olmap: ol_Map

    private pictureOverlays: { zone: DatalayerZone, overlay: ol_Overlay }[] = []
    private currentPictureOverlay: ol_Overlay

    private currentZone: EditFeature

    private zoneChangedWatcher: Function

    constructor(
        private $scope: ng.IScope,
        private map: DatalayersMap,
        private deps: IDatalayerMapDependencies
    ) {

        this.olmap = map.getMap()

    }

    dispose() {

        if (this.zoneChangedWatcher) {
            this.zoneChangedWatcher()
        }

        this.removePictureOverlay()
        this.removePictureOverlays()

    }

    setup(zones: DatalayerZone[]) {

        if (zones) {
            zones.filter(z => z.picture).forEach(z => this.setPictureOverlay(z));
        }

    }

    setCurrentZone(zone: EditFeature) {
        this.currentZone = zone
        const overlay = zone ? this.pictureOverlays.find(o => o.zone === zone) : null
        this.currentPictureOverlay = overlay ? overlay.overlay : null
    }

    public setPictureOverlay(zone: DatalayerZone) {

        const { olmap } = this

        if (zone.feature && zone.picture && !this.pictureOverlays.find(o => o.zone === zone)) {

            const { overlay } = omnia.map.createPictureOverlay(this.$scope, this.deps.$compile, zone.feature, zone.picture);
            olmap.addOverlay(overlay);

            this.pictureOverlays.push({ zone: zone, overlay });

            if (this.zoneChangedWatcher) {
                this.zoneChangedWatcher();
            }

            // Note: this was part of an older version, has been commented at some point,
            // and probably needs to be reviewed
            //this.zoneChangedWatcher = this.$scope.$watch(() => this._currentZone.getCurrentWKT(), () => this.updatePictureOverlayPosition(this._currentZone));

            olmap.render();

        }

    }

    removePictureOverlay() {
        if (this.currentPictureOverlay) {
            if (this.zoneChangedWatcher) {
                this.zoneChangedWatcher();
            }

            this.olmap.removeOverlay(this.currentPictureOverlay);

            this.pictureOverlays = this.pictureOverlays.filter(o => o.zone !== this.currentZone);
            this.currentPictureOverlay = null;
        }
    }

    private removePictureOverlays() {
        if (this.pictureOverlays.length) {
            this.pictureOverlays.forEach(o => this.olmap.removeOverlay(o.overlay));
            this.pictureOverlays = [];
        }
    }

    updatePictureOverlayPosition(zone: IDatalayerZoneMapInstance) {

        var overlay = this.pictureOverlays.find(o => o.zone === zone);

        if (overlay) {
            var geom = zone.feature.getGeometry();
            var coordinates = (<any>geom).getInteriorPoint
                ? (<any>geom).getInteriorPoint().getFirstCoordinate()
                : ol_extent.getCenter(zone.feature.getGeometry().getExtent());

            overlay.overlay.setPosition(coordinates);
        }

    }

    removePicture(zone: EditFeature) {

        zone.picture = null;
        this.removePictureOverlay();

    }

    selectPicture(zone: EditFeature) {

        const args: doclib.IDocumentLibraryArguments = {
            selection: true,
            limitToPictures: true
        }

        this.deps.shell.showComponentAsDialog(doclib.ReactDocumentLibrary, args,
            {
                size: 'full-screen',
                backdrop: 'static'
            }).then(r => {
                if (r && r.length) {
                    zone.picture = r[0];
                    if (zone.picture.ExifLocation) {
                        zone.usePictureCoordinates = true;
                        this.usePictureCoordinatesChanged();
                    }
                    this.setPictureOverlay(zone);
                }
            });

    }

    showPicture(picture: ImportDocument) {

        const document: ImportDocument = angular.extend({}, picture);

        const args = { document, manageLibrary: false }

        this.deps.shell.showComponentAsDialog(doclib.ReactDocumentPropertiesPopup,
            args,
            { size: 'lg' }).then(r => {
                if (r) {
                    picture.Description = document.Description;
                }
            });

    }

    usePictureCoordinatesChanged() {
        if (this.currentZone.usePictureCoordinates) {
            this.map.viewExtent(this.currentZone.feature);
        }
    }

}
